import UpdateDeleteInputGroup from 'components/UpdateDeleteInputGroup';
import Material from 'models/Material';
import { Badge, Input } from 'reactstrap';
import formatCurrency from 'utils/formatCurrency';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { memo, useEffect } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import traduzirNomeMaterial from 'utils/traduzirNomeMaterial';
import { Descricao, Td, Tr } from './styles';

interface PropostaMaterialItem {
  id: number;
  quantidade: number;
  valor: number | null;
  valorTotal: number | null;
  atividade: number | null;
  criadoManualmente?: boolean | false;
  material: Material;
  importacaoMaterialId?: number | null;
  importacaoMaterial?: any | null;
  isAvulso?: boolean | false;
  produtoAtividade: any | null;
  produtoAtividadeId: number | null;
}

function MaterialItem({
  propostaMaterial,
  onClickUpdate,
  onClickDelete,
  disabled,
  handleChangeValue,
  canEdit,
  canDelete,
  acessoLimitadoListaMateriais,
  acessoLimitado,
  isAvulso,
  isFaturamentoDireto,
  isChecked,
  isFaturamentoDiretoOriundoVersaoAnterior = false,
  onAddFinanciamentoDireto,
}: {
  propostaMaterial: PropostaMaterialItem;
  onClickUpdate?: () => void;
  onClickDelete?: () => void;
  disabled?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  handleChangeValue?: (
    id: number,
    name: string,
    value: number | string,
  ) => void;
  acessoLimitadoListaMateriais: boolean;
  acessoLimitado?: boolean;
  isAvulso?: boolean;
  isFaturamentoDireto?: boolean;
  isFaturamentoDiretoOriundoVersaoAnterior?: boolean;
  isChecked?: boolean;
  onAddFinanciamentoDireto?: () => void;
}): JSX.Element {
  const {
    id,
    atividade,
    material,
    quantidade,
    valor,
    valorTotal,
    criadoManualmente,
    importacaoMaterialId,
    importacaoMaterial,
    produtoAtividade,
  } = propostaMaterial;

  const valorMoeda = formatCurrency(valor);
  const valorMoedaTotal = formatCurrency(valorTotal);

  function mostrarTooltip() {
    const mostrarImportado =
      criadoManualmente !== undefined &&
      criadoManualmente === true &&
      importacaoMaterialId !== null;

    const mostrarCriadoManualmente =
      criadoManualmente !== undefined && criadoManualmente === true;

    if (mostrarImportado) {
      return (
        <span
          title={`Material importado do arquivo ${importacaoMaterial.nomeArquivo}`}
        >
          <Badge
            style={{ backgroundColor: '#FFDE21', color: '#000000' }}
            className="ml-2"
          >
            I
          </Badge>
        </span>
      );
    }

    if (mostrarCriadoManualmente) {
      return (
        <span title="Material adicionado manualmente na configuração">
          <Badge color="success" className="ml-2">
            M
          </Badge>
        </span>
      );
    }

    return '';
  }

  return (
    <Tr semPreco={valor === 0}>
      {isAvulso && (
        <Td>
          <Badge color="info" className="mr-2">
            Item avulso
          </Badge>
        </Td>
      )}
      <Td>
        {produtoAtividade
          ? traduzirProdutoAtividade(produtoAtividade, true)
          : ''}
      </Td>
      <Td>
        <Descricao>
          {traduzirNomeMaterial(material)}{' '}
          {isFaturamentoDiretoOriundoVersaoAnterior && (
            <Badge
              style={{
                background: `#1a7bb9`,
                color: '#ffffff',
              }}
              className="ml-2"
            >
              Faturamento Direto
            </Badge>
          )}
          {mostrarTooltip()}
        </Descricao>
      </Td>
      <Td className="text-center">
        {canEdit ? (
          <Input
            key={id}
            className="mt--1 mb-2"
            bsSize="sm"
            type="number"
            min={1}
            value={String(quantidade)}
            onChange={event =>
              handleChangeValue
                ? handleChangeValue(
                    id,
                    'quantidade',
                    parseInt(event.target.value, 10),
                  )
                : undefined
            }
          />
        ) : (
          quantidade
        )}
      </Td>
      <Td className="text-right" hidden={acessoLimitadoListaMateriais}>
        {valorMoeda}
      </Td>
      <Td className="text-right" hidden={acessoLimitadoListaMateriais}>
        {valorMoedaTotal}
      </Td>
      {!acessoLimitadoListaMateriais && !isFaturamentoDireto && (
        <Td>
          <UpdateDeleteInputGroup
            className="mr--3"
            disabled={disabled}
            canEdit={canEdit}
            canDelete={canDelete}
            onClickUpdate={onClickUpdate}
            onClickDelete={onClickDelete}
          />
        </Td>
      )}
      {isFaturamentoDireto && (
        <Td className="text-center w-auto">
          <Checkbox
            color="primary"
            className="mr-1 float-center"
            checked={isChecked}
            title="Faturamento Direto"
            onChange={onAddFinanciamentoDireto}
          />
        </Td>
      )}
    </Tr>
  );
}

export default memo(MaterialItem);
